import React from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';

export const FollowUpModal = ({ open, onOpenChange, followUp, setFollowUp, onSave, isSaving }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="followup-modal" aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Create Follow-Up</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Title *</Label>
            <Input value={followUp.title} onChange={(e) => setFollowUp(f => ({ ...f, title: e.target.value }))} placeholder="e.g., Follow up on quote" />
          </div>
          <div className="space-y-2">
            <Label>Description</Label>
            <Textarea value={followUp.description} onChange={(e) => setFollowUp(f => ({ ...f, description: e.target.value }))} placeholder="Additional details..." />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Due Date *</Label>
              <Input type="date" value={followUp.due_date} onChange={(e) => setFollowUp(f => ({ ...f, due_date: e.target.value }))} />
            </div>
            <div className="space-y-2">
              <Label>Priority</Label>
              <Select value={followUp.priority} onValueChange={(v) => setFollowUp(f => ({ ...f, priority: v }))}>
                <SelectTrigger><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="low">Low</SelectItem>
                  <SelectItem value="medium">Medium</SelectItem>
                  <SelectItem value="high">High</SelectItem>
                  <SelectItem value="urgent">Urgent</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onSave} disabled={isSaving} data-testid="save-followup-btn">
            {isSaving && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
            Create Follow-Up
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
